import { useQuery } from "@tanstack/react-query";
import { getDocumentFileUrl } from "@/lib/api";
import {
  getCachedFileUrl,
  isFileUrlExpired,
  setCachedFileUrl,
} from "@/lib/documentCache";
import { queryKeys } from "@/lib/cache/queryKeys";
import { staleTimes } from "@/lib/cache/staleTimes";

export function useDocumentFileUrl(id, { enabled = true } = {}) {
  return useQuery({
    queryKey: queryKeys.documentFileUrl(id),
    queryFn: async () => {
      const cached = getCachedFileUrl(id);
      if (cached && !isFileUrlExpired(cached)) return cached;
      const meta = await getDocumentFileUrl(id);
      setCachedFileUrl(id, meta);
      return getCachedFileUrl(id);
    },
    staleTime: staleTimes.documentDetail,
    enabled: Boolean(id) && enabled,
  });
}
